import { render, staticRenderFns } from "./textbookPage.vue?vue&type=template&id=7f683819&scoped=true"
import script from "./textbookPage.vue?vue&type=script&lang=js"
export * from "./textbookPage.vue?vue&type=script&lang=js"
import style0 from "./textbookPage.vue?vue&type=style&index=0&id=7f683819&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f683819",
  null
  
)

export default component.exports